import { apiRequest } from "./client";
import type { GrievanceAction, FilterStatus, Status } from "./admin";

export type TestTicketListItem = {
  id: number;
  application_id: string;
  grievance_preview: string;
  status: Status;
  sent_datetime: string | null;
  has_attachment: boolean;
};

export type TestTicketListResponse = {
  items: TestTicketListItem[];
  total: number;
};

export type TestTicketDetail = {
  id: number;
  tab_id: string;
  application_id: string;
  grievance: string;
  sent_datetime: string | null;
  status: Status;
  bot_response: string | null;
  replied_grievance: string | null;
  replied_by: string | null;
  replied_datetime: string | null;
  replied_by_ip: string | null;
  has_attachment: boolean;
  attachment_filename: string | null;
  attachment_mime: string | null;
  created_by: number | null;
  created_at: string | null;
  actions: GrievanceAction[];
};

export type TestListParams = {
  status: FilterStatus[];
  q: string;
  limit?: number;
  offset?: number;
};

function base(tabId: string) {
  return `/admin/tabs/${tabId}/test-tickets`;
}

export function listTestTickets(tabId: string, params: TestListParams) {
  return apiRequest<TestTicketListResponse>(base(tabId), {
    query: {
      status: params.status,
      q: params.q || undefined,
      limit: params.limit ?? 50,
      offset: params.offset ?? 0,
    },
  });
}

export function getTestTicket(tabId: string, id: number) {
  return apiRequest<TestTicketDetail>(`${base(tabId)}/${id}`);
}

export function createTestTicket(
  tabId: string,
  values: { application_id: string; grievance_text: string; attachment?: File | null },
) {
  const fd = new FormData();
  fd.append("application_id", values.application_id);
  fd.append("grievance_text", values.grievance_text);
  if (values.attachment) fd.append("attachment", values.attachment);
  return apiRequest<TestTicketDetail>(base(tabId), {
    method: "POST",
    formData: fd,
  });
}

export function generateTestResponse(tabId: string, id: number) {
  return apiRequest<{ bot_response: string }>(`${base(tabId)}/${id}/generate`, {
    method: "POST",
  });
}

export function sendTestReply(tabId: string, id: number, responseText: string) {
  return apiRequest<{ ok: boolean; replied_by: string }>(`${base(tabId)}/${id}/reply`, {
    method: "POST",
    body: { response_text: responseText },
  });
}

export function deleteTestTicket(tabId: string, id: number) {
  return apiRequest<{ ok: boolean }>(`${base(tabId)}/${id}`, {
    method: "DELETE",
  });
}
